<login (onLoginClick)="onLogin()"
       (onTenantSelect)="tenantSelect($event)"
       (onChangeUser)="changeUser()"
       (onGoToPrimaryLogin)="goToPrimaryLogin()"
       [isAltLogin]="isAltLogin"
       [loading]="loading"
       [selectedTenant]="selectedTenant"
       [selectTenants]="selectTenants"
       [tenants]="tenants"
       [errorMessage]="errorMessage">
</login>
